const initialState = {
    machineList: [],
    siteList: [],
    totalMachinesCount: 0,
    machineLogs: []
};

const machineReducer = (state = initialState, action) => {
    switch (action.type) {
        case "MACHINE_LIST": {
            return {
                ...state,
                machineList: action.payload?.machines,
                totalMachinesCount: action.payload?.totalCount || 0,
            }
        }
        case "MACHINE_LOGS": {
            return {
                ...state,
                machineLogs: action.payload
            }
        }
        case "SITES_LIST": {
            return {
                ...state,
                siteList: action.payload?.sites
            }
        }
        case "MACHINE_EVENT_LOGS": {
            return {
                ...state,
                machineEventLogs: action.payload
            }
        }
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};

export default machineReducer;